<style lang="sass">

    @import ../../common/styles/mixins
    @import ../../common/styles/settings

    .block-search
        position: relative
        transition: padding $speed-fast $authentic-motion, margin $speed-fast $authentic-motion

        +media("<=768px")
            min-width: 2rem
            min-height: 2rem
            box-sizing: border-box

        &.icon
            padding-left: 2.5rem
            &:before
               top: calc(50% - .75rem)
               left: .5rem
               +media("<=768px")
                   top: 5px
                   left: 15px

        input
            background: transparent
            border: 0!important
            background-image: none!important
            width: 9rem
            font-family: 'Roboto', sans-serif
            transition: width $speed-fast $authentic-motion
            +media("<=1024px")
                width: 7rem
            +media("<=768px")
                position: fixed
                left: 0
                width: 100%
                background: $color-base
                top: 4rem
                height: 4rem
                padding: 0 2rem
                box-sizing: border-box
                font-size: 1rem
                -webkit-appearance: none
                border-radius: 0
                display: none

        input[placeholder], [placeholder], *[placeholder]
            color: #fff!important

        ::placeholder
            opacity: 1

        input:focus
            outline-style: none

        [data-drupal-selector="edit-actions"]
            display: none

        &.open
            +media(">768px")
                border: 1px solid white
                padding: 1rem 1rem 1rem 2.5rem
                margin-right: 1rem
                input
                    width: 18rem

            +media("<=768px")
                input
                    display: block


    .js-pager__items
        text-align: center
        li
            display: inline-block
            color: $color-gray-medium
            margin-right: 2rem
            &.is-active
                color: $color-text
            &:last-child
                margin-right: 0

    .pager__item--first
        display: none!important

    .pager__item--previous
        color: $color-text!important

    .pager__item--next
        color: $color-gray-medium

    .pager__item--last
        display: none!important

    #edit-actions--2, #edit-actions--3, #edit-actions--5
        display: none


</style>

<script>
    import $ from 'jquery'

    export default  {

        mounted: function () {


            this.$input = $(".block-search input");
            this.$input.attr('placeholder', 'Rechercher');
            this.$input.on("blur", () => { setTimeout(this.collapse.bind(this), 100) });

            if ( $(window).width() <= 768 ) {
                $(this.$el).on("click", () => {
                    if ( $(this.$el).hasClass("open") )
                        this.collapse();
                    else
                        this.expand();
                });
                $(".layout-content").on("click", ($event) => {
                    this.collapse();
                });
            } else {
                this.$input.on("click", this.expand.bind(this));
            }



            // ???
            $(this.$el).find('#edit-keys--2').attr('placeholder', 'Rechercher');
        },

        methods: {

            expand() {
                this.$input.attr("placeholder", "Formulez votre demande, question...");
                $(this.$el).addClass("open");
                this.$input.focus();
            },

            collapse() {
                this.$input.attr("placeholder", "Rechercher");
                $(this.$el).removeClass("open");
            }

        }

    }

</script>
